export default ".wrapper {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.wrapper--active {\n  pointer-events: auto;\n}";